(function () {
  if (!theme.searchActive) return;

  // Wait for filter bar header to exist
  const target = document.body;
  const observer = new MutationObserver(() => {
    const header = document.querySelector('#isp_left_container_header');
    if (header) {
      header.innerHTML = `
        <h2>Filter</h2>
        <button class="filter__close-btn">
          <span class="visually-hidden">Close</span>
          <span aria-hidden="true">&times;</span>
        </button>
      `;


      filtersClicked();
      // Stop observing when we find the element
      observer.disconnect();
    }
  });

  observer.observe(target, { subtree: true, childList: true });

  document.addEventListener('click', event => {
    if (!event.target.closest('#isp_right_container') && !event.target.closest('.filter__close-btn')) return;
    document.getElementById('isp_refine_nevigation').click();
  });

})();

function filtersClicked() {
  // Filters clicked gray background logic
  document.addEventListener('click', event => {
    const target = event.target;

    if (target.closest('.family-tab-value') || target.closest('.isp_facet_value') || target.closest('.isp_on_sale_only_checkbox')) {
      const filterClickedContainer = target.closest('div');
      // Add a class to keep track of if the filter is newly selected
      if (filterClickedContainer.classList.contains('selected-new')) {
        filterClickedContainer.classList.remove('selected-new');
        // Making sure the selected class gets removed from all sub children
        const filterClickedContainerChildrenSelected = filterClickedContainer.querySelectorAll('.selected-new');
        filterClickedContainerChildrenSelected.forEach(filterClickedContainerChildSelected => {
          filterClickedContainerChildSelected.classList.remove('selected-new');
        });
        // check if the apply filter overlay should be active
        applyFilterOverlay();
      } else {
        filterClickedContainer.classList.add('selected-new');
        target.classList.add('selected-new');
        // check if the apply filter overlay should be active
        applyFilterOverlay();
      }

    }

    // When the apply filter button or reset filter button is clicked we want to reset everything
    if (target.matches('#custom-desktop-apply-btn') || target.matches('#custom-desktop-reset-btn')) {
      const filterClickedContainerChildrenSelected = document.querySelectorAll('.selected-new');
      filterClickedContainerChildrenSelected.forEach(filterClickedContainerChildSelected => {
        filterClickedContainerChildSelected.classList.remove('selected-new');
      });

      // check if the apply filter overlay should be active
      applyFilterOverlay();
    }

  });
}

function applyFilterOverlay() {
  const newFiltersApplied = document.querySelector('.selected-new');
  const plpContainer = document.getElementById('isp_center_container');
  const applyFiltersCTA = document.getElementById('custom-desktop-apply-btn');
  const facetContainer = document.getElementById('isp_left_container_facets');

  // Add tooltip to facet container, if necessary
  if (facetContainer) {
    const tooltip = facetContainer.querySelector('.apply-filters-tooltip');
    if (!tooltip) {
      const tooltipHTML = `
        <div class="apply-filters-tooltip">
          <span class="apply-filters-tooltip__text">
            Select <strong>‘Apply Filters’</strong> to View Results
          </span>
          <div class="apply-filters-tooltip__bg"></div>
        </div>`;

      facetContainer.insertAdjacentHTML('afterbegin', tooltipHTML);
    }
  }

  // Add/remove .is-active class to the appropriate
  // elements from truthiness of newFiltersApplied
  [plpContainer, applyFiltersCTA, facetContainer]
    .forEach(el => el && el.classList.toggle('is-active', newFiltersApplied));
}

// accordion for collection description on mobile
const collectionDescAccordion = function () {
    const collectionDescription = document.querySelector('.collection-description');
    if (collectionDescription) {
      const collectionTitle = document.querySelector('.collection__accordion--title');
      const openedHeight = window.getComputedStyle(collectionDescription).height;

      const accordionStyle = document.createElement('style');
      accordionStyle.classList.add('collection__accordion--style');
      accordionStyle.innerHTML = `@media (max-width: 767px){
          .collection__accordion--title.accordion--open ~ .collection__accordion--description {
            max-height: ${openedHeight};
          }
        }`;
      collectionTitle.before(accordionStyle);

      collectionTitle.addEventListener('click', function (e) {
        const target = e.target.closest('.collection__accordion--title');

        if (target.classList.contains('accordion--open')) {
          target.classList.remove('accordion--open');
        } else {
          target.classList.add('accordion--open');
        }
      });
    }
}
collectionDescAccordion();

// change opened height on resize
const updateOpenedHeight = function () {
  const collectionDescStyle = document.querySelector('.collection__accordion--style');
  if (collectionDescStyle) {
    const description = document.querySelector('.collection-description');
    const openedHeight = window.getComputedStyle(description).height;

    collectionDescStyle.innerHTML = `@media (max-width: 767px){
      .collection__accordion--title.accordion--open ~ .collection__accordion--description {
        max-height: ${openedHeight};
      }
    }`;
  } else {
    collectionDescAccordion();
  }
}

window.addEventListener('resize', debounce(function () {
  updateOpenedHeight();
}, 500));
